// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1__be684021eebc67184603","cls2":"PingAnswerStyles-cls2___a18f60ae11a97d6f436 PingAnswerStyles-cls1__be684021eebc67184603"};